/**
 * Google Tag Manager Service
 *
 * 负责在海外环境中动态注入 Google Tag Manager 代码
 */

export interface GoogleTagManagerService {
    /**
     * 初始化 GTM
     * 根据用户所在地区判断是否需要注入 GTM 代码
     * - 如果是中国地区(siteRegion === 'CN')，不注入
     * - 如果是海外地区，动态注入 GTM 代码到页面
     */
    initialize(): void;
}

export const GoogleTagManagerService = Symbol('GoogleTagManagerService');
